import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components'

export const StyledWorkshopSelectCard = styled.div`
  padding: 24px 32px;
  background-color: ${theme.colors.neutral50};
  border-radius: ${theme.borderRadius};
  cursor: pointer;
`

export const StyledWorkshopSelectCardContent = styled.div`
  position: relative;
`

export const StyledWorkshopSelectBox = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 24px;
`

export const StyledWorkshopSelectCardCategory = styled.p`
  color: ${theme.colors.primaryBase};
  font-family: 'Inter';
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  text-transform: uppercase;
`

export const StyledWorkshopSelectCardTitle = styled.h4`
  display: -webkit-box;
  overflow: hidden;
  min-height: 56px;
  padding-right: 24px;
  -webkit-box-orient: vertical;
  color: ${theme.colors.secondaryBase};
  font-family: 'Inter';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: -0.6px;
  -webkit-line-clamp: 2;
  line-height: 28px;
`

export const StyledWorkshopSelectCardInfo = styled.div`
  margin-top: 20px;
`

export const StyledWorkshopInfoRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  gap: 8px;
`

export const StyledWorkshopIcon = styled.img`
  width: 20px;
  height: 20px;
`
export const StyledWorkshopDateText = styled.p`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.2px;
  -webkit-line-clamp: 1;
  line-height: 28px;
`

export const StyledInfluencerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-top: 16px;
  gap: 20px;
  > div {
    width: calc(50% - 12px);
  }
`

export const StyledInfluencer = styled.div`
  display: flex;
  min-height: 134px;
  flex-direction: column;
  align-items: center;
`

export const StyledInfluencerAvatar = styled.img`
  width: 64px;
  height: 64px;
  background: white;
  border-radius: 50%;
  object-fit: cover;
`

export const StyledInfluencerName = styled.p`
  display: -webkit-box;
  overflow: hidden;
  margin-top: 8px;
  -webkit-box-orient: vertical;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.2px;
  -webkit-line-clamp: 2;
  line-height: 22px;
  text-align: center;
`

export const StyledInfluencerWorkPlace = styled.p`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  font-size: 12px;
  font-weight: 400;
  -webkit-line-clamp: 2;
  line-height: 18px;
  text-align: center;
`
